export default class MissingEmailException extends Error {
  constructor(message) {
    super(message);
    this.name = 'MissingEmailException';
    this.code = 'custom/missing-email';
  }
}
